import { styled } from '@fluentui/react';
import { connect } from 'react-redux';
import { Environment, SourceApps } from '../../../models/constants/constants';
import { IAppState } from '../../../models/reduxState';
import { getUpsellModalityId } from '../../../utilities';
import { isAmcSelector, isGetHelpSelector, isSmbHubSelector } from '../../app/selectors/contactUsSelector';
import { AgentModalityOption } from '../presentationalComponents/AgentModalityOption';
import { navigateToPage, updateDraftRequest } from '../reduxUpdater/actions/modalitySectionActions';
import { dispatchCreateRequest } from '../reduxUpdater/dispatchers/contactUsDispatchers';
import { getContactUsStyles } from '../styles/contactUsStyles';

const mapStateToProps = (state: IAppState, _ownProps: any) => {
  return {
    localizedDaysOfWeek: state.ContactState.ModalitySectionState.localizedDaysOfWeek,
    alchemyThemeRoutingShowWaitTime: state.ContactState.ModalitySectionState.alchemyThemeRoutingShowWaitTime,
    alchemyThemeRoutingShowHOOPs: state.ContactState.ModalitySectionState.alchemyThemeRoutingShowHOOPs,
    showModalitiesStickyFooter: state.ContactState.SelfHelpAlchemyState.showModalitiesStickyFooter,
    draftRequestUserEmail: !!state.ContactState.ModalitySectionState.draftRequest
      ? state.ContactState.ModalitySectionState.draftRequest.UserEmail
      : null,
    userInfo: state.ContactState.ModalitySectionState.userInfo,
    isGroupMe: state.GlobalState.sourceApp === SourceApps.GroupMe,
    isOutlookDotCom: state.GlobalState.environment === Environment.OutlookDotCom,
    upsellModalityId: getUpsellModalityId(state.ContactState.ModalitySectionState.modalityResponse),
    isSignUp: state.GlobalState.sourceApp === SourceApps.SignUp,
    isLiveChatEmailRequirementDisabled: state.ContactState.ModalitySectionState.isLiveChatEmailRequirementDisabled,
    isAmc: isAmcSelector(state),
    isGetHelp: isGetHelpSelector(state),
    alchemyTheme: state.ContactState?.SelfHelpAlchemyState?.alchemyResults?.Theme?.Name,
    isSmbHub: isSmbHubSelector(state),
  };
};

const mapDispatchToProps = {
  updateDraftRequest,
  dispatchCreateRequest,
  navigateToPage,
};

export const AgentModalityOptionContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(styled(AgentModalityOption, getContactUsStyles));
